import React, { useEffect, useState } from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SelectShell from '@atoms/SelectShell';
import { useOptions, useCurrentSelections } from './RefinementNestedMenuHooks';
import { Ul } from '@styled';

const ParentOption = styled.a`
    background-color: transparent;
    box-sizing: border-box;
    color: inherit;
    cursor: default;
    display: block;
    font-size: inherit;
    padding: 8px 12px;
    user-select: none;
    width: 100%;

    &:hover {
        background-color: #deebff;
        color: black;
    }
`;

const ChildOption = styled.a`
    background-color: transparent;
    box-sizing: border-box;
    color: inherit;
    cursor: default;
    display: block;
    font-size: inherit;
    padding: 8px 12px 8px 38px;
    user-select: none;
    width: 100%;

    &:hover {
        background-color: #deebff;
        color: black;
    }
`;

const RefinementNestedMenu = ({
    // Passed
    placeholder = '',

    // Algolia
    currentRefinement,
    items,
    refine,
}) => {
    const [optionFilterText, setOptionFilterText] = useState('');
    const { options } = useOptions({ filterText: optionFilterText, algoliaItems: items });
    const { currentSelections } = useCurrentSelections({ algoliaCurrentRefinement: currentRefinement });

    if (!options) {
        return null;
    }

    return (
        <SelectShell
            currentSelections={currentSelections}
            inputValue={optionFilterText}
            placeholder={placeholder}
            onCurrentSelectionRemove={selection => {
                const algoliaItem = items.find(item => item.label === selection.value);
                refine(algoliaItem.value);
            }}
            onInputChange={setOptionFilterText}
        >
            <Ul>
                {options.map(filterOption => (
                    <li key={filterOption.label}>
                        <ParentOption
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                refine([filterOption.label]);
                            }}
                        >
                            <span>
                                {filterOption.label} ({filterOption.count})
                            </span>
                        </ParentOption>

                        {filterOption.children.length > 0 && (
                            <Ul
                                style={{
                                    display:
                                        filterOption.isRefined || filterOption.children.find(child => child.isRefined)
                                            ? 'block'
                                            : 'none',
                                }}
                            >
                                {filterOption.children.map(filterOptionChild => {
                                    // e.g. Architecture/Design/Engineering > ARC04-Graphic Design
                                    const childLabelCode = filterOptionChild.label.split(' > ')[1];
                                    // ARC04-Graphic Design - remove code
                                    const childLabelParts = childLabelCode.split('-');
                                    const childLabel =
                                        childLabelParts.length > 0 ? childLabelParts[1] : childLabelParts[0];

                                    return (
                                        <li key={filterOptionChild.label}>
                                            <ChildOption
                                                href="#"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    refine([filterOptionChild.label]);
                                                }}
                                            >
                                                <span>
                                                    {childLabel} ({filterOptionChild.count})
                                                </span>
                                            </ChildOption>
                                        </li>
                                    );
                                })}
                            </Ul>
                        )}
                    </li>
                ))}
            </Ul>
        </SelectShell>
    );
};

RefinementNestedMenu.propTypes = {
    // Passed
    placeholder: PropTypes.string,

    // Algolia
    currentRefinement: PropTypes.arrayOf(PropTypes.string).isRequired,
    items: PropTypes.array.isRequired,
    refine: PropTypes.func.isRequired,
};

export default connectRefinementList(RefinementNestedMenu);
